import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';

import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

import HelpFAQPage from "./pages/HelpFAQPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";

import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import Create from "./pages/Create";
import PurchaseSuccess from "./pages/PurchaseSuccess";
import Site from "./pages/Site";
import Renew from "./pages/Renew";
import AccountSetting from "./pages/AccountSetting";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:email/:token" element={<ResetPasswordPage />} />

        <Route path="/help-faq" element={<HelpFAQPage />} />
        <Route path="/help-faq/:id" element={<HelpFAQPage />} />

        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/create"
          element={
            <ProtectedRoute>
              <Create />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/payment-success"
          element={
            <ProtectedRoute>
              <PurchaseSuccess />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/site/:site_id"
          element={
            <ProtectedRoute>
              <Site />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/site/renew/:site_id"
          element={
            <ProtectedRoute>
              <Renew />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/account-settings"
          element={
            <ProtectedRoute>
              <AccountSetting />
            </ProtectedRoute>
          }
        />
        
      </Routes>
    </Router>
  );
}

export default App;
